import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({ palette }) => {
  return {
    DatePickerRoot: {
      width: 143,
      zIndex: -100,
      "& > div": {
        borderColor: "rgba(172, 174, 196, 0.8) !important",
        height: 40,
        borderRadius: "8px !important",
        "& div div span": {
          top: "10px !important"
        },
      },
      "& input": {
        opacity: 1,
        fontFamily: "Source Sans Pro",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "18px",
        paddingLeft: 33,
      },
    },
    expires_at: {
      "& input": {
        color: "#E22E2E",
      },
    },
    wrapperContainer: {
      position: "relative",
    },
    containerIcon: {
      position: "absolute",
      left: 10,
      top: 12,
      zIndex: 5,
    },
    icon: {
      width: 16,
      height: 16,
      color: "rgba(100, 100, 100, 1)"
    },

    // MENU
    menuCustom: {
      zIndex: 1000,
      "& .rs-calendar-table-cell-content": {
        background: "transparent !important",
        color: "#0B2033 !important"
      },
      "& .rs-calendar-table-cell-selected .rs-calendar-table-cell-content": {
        background: "#0B2033 !important",
        color: "#ffffff !important"
      },
      "& .rs-calendar-table-cell-content:hover": {
        background: "#0B2033 !important",
        color: "#ffffff !important"
      },
      "& .rs-calendar-table-header-cell-content": {
        color: "#0B2033 !important",
        fontFamily: "Source Sans Pro !important",
        fontSize: "14px !important",
        fontStyle: "normal !important",
        fontWeight: "600 !important",
        lineHeight: "18px !important",
      },
      "& .rs-calendar-header-title": {
        color: "#0B2033 !important",
        fontFamily: "Source Sans Pro !important",
        fontSize: "16px !important",
        fontStyle: "normal !important",
        fontWeight: "700 !important",
        lineHeight: "18px !important",
        textTransform: "capitalize",
      },
      "& .rs-calendar-header-error, .rs-calendar-header-error:focus, .rs-calendar-header-error:hover": {
        background: "none !important",
        color: "#0B2033 !important"
      },
      "& .rs-calendar-month-view .rs-calendar-header-title-date.rs-calendar-header-error:focus, .rs-calendar-month-view .rs-calendar-header-title-date.rs-calendar-header-error:hover:active": {
        color: "#0B2033 !important"
      },
      "& .rs-btn": {
        height: "40px !important",
        width: "85px !important"
      },
      "& .rs-calendar-header-title-date": {
        width: "130px !important"
      },
      "& .rs-calendar-header-backward": {
        width: "45px !important"
      },
      "& .rs-calendar-header-forward": {
        width: "45px !important"
      },
      "& .rs-calendar-table-cell-disabled .rs-calendar-table-cell-content": {
        color: "#6B6F93 !important",
        textDecoration: "none !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: "none !important",
          color: "#6B6F93 !important"
        }
      },
      "& .rs-calendar-table-cell-is-today .rs-calendar-table-cell-content": {
        background: "transparent !important",
        color: "#6B6F93 !important",
        textDecoration: "none !important",
        opacity: 1,
        boxShadow: "inset 0 0 0 1px #0B2033 !important"
      },
      "& .rs-calendar-table-cell-un-same-month .rs-calendar-table-cell-content": {
        color: "#6B6F93 !important",
        "&:hover": {
          color: "#ffffff !important",
        }
      },
    }
  };
});
export default useStyles;
